// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".trace-detail .upload-area[data-v-7170a397]{margin-right:40px;width:240px}.trace-detail .upload-area[data-v-7170a397]  .el-upload{display:block}.trace-detail .popup-box .el-button[data-v-7170a397]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
